/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_DescriptionInputs */

const en_marker_import_description = /** @type {(inputs: Marker_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import markers from JSON or EDL files and configure import settings`)
};

const fr_marker_import_description = /** @type {(inputs: Marker_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer des marqueurs depuis des fichiers JSON ou EDL et configurer les parametres d'importation`)
};

const de_marker_import_description = /** @type {(inputs: Marker_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importieren Sie Marker aus JSON- oder EDL-Dateien und konfigurieren Sie die Importeinstellungen.`)
};

const it_marker_import_description = /** @type {(inputs: Marker_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa marcatori da file JSON o EDL e configura le impostazioni di importazione`)
};

const ru_marker_import_description = /** @type {(inputs: Marker_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортируйте маркеры из файлов JSON или EDL и настройте параметры импорта.`)
};

const es_marker_import_description = /** @type {(inputs: Marker_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar marcadores desde archivos JSON o EDL y configurar los ajustes de importación`)
};

const zh_cn2_marker_import_description = /** @type {(inputs: Marker_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 JSON 或 EDL 文件导入标记并配置导入设置`)
};

const ja_marker_import_description = /** @type {(inputs: Marker_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON または EDL ファイルからマーカーをインポートし、インポート設定を構成します。`)
};

const hi_marker_import_description = /** @type {(inputs: Marker_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON या EDL फ़ाइलों से मार्कर आयात करें और आयात सेटिंग्स कॉन्फ़िगर करें`)
};

const pt_pt2_marker_import_description = /** @type {(inputs: Marker_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe marcadores de arquivos JSON ou EDL e configure as opções de importação.`)
};

/**
* | output |
* | --- |
* | "Import markers from JSON or EDL files and configure import settings" |
*
* @param {Marker_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_description = /** @type {((inputs?: Marker_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_description(inputs)
	if (locale === "de") return de_marker_import_description(inputs)
	if (locale === "it") return it_marker_import_description(inputs)
	if (locale === "ru") return ru_marker_import_description(inputs)
	if (locale === "es") return es_marker_import_description(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_description(inputs)
	if (locale === "ja") return ja_marker_import_description(inputs)
	if (locale === "hi") return hi_marker_import_description(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_description(inputs)
	return en_marker_import_description(inputs)
});